// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_wrapper_1ibHo","message":"Card_message_2Xr8h","inactive":"Card_inactive_1ANfw","error":"Card_error_2oFGg"};